import React, { useState } from 'react';

function ResetPassword() {
  const [password, setPassword] = useState('');
  const [status, setStatus] = useState(null);

  const token = window.location.pathname.split('/').pop();

  const handleSubmit = async () => {
    if (!password) return;

    try {
      const res = await fetch('https://sales-app-backend-production.up.railway.app/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password })
      });

      const data = await res.json();

      if (data.ok) {
  localStorage.setItem('user', JSON.stringify(data.user));
  window.location.href = '/';
} else if (data.error === 'Token expired') {
  setStatus('expired');
} else {
  setStatus('error');
}
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="h-screen flex">

      {/* LEFT PANEL */}
      <div className="w-[35%] bg-white flex flex-col justify-center px-12">

        <img
          src="/LogoComplementCubeBlue.png"
          alt="Logo"
          className="w-10 mb-6"
        />

        <h2 className="text-2xl font-semibold mb-2">Reset your password</h2>
        <p className="text-sm text-gray-500 mb-6">
          Enter a new password to access your account.
        </p>

        {status === 'success' ? (
          <div className="text-green-600 text-sm">
            Password updated. You can now log in.
          </div>
        ) : (
          <>
            <input
              type="password"
              placeholder="New password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="border p-2 rounded w-full mb-3"
            />

            <button
              onClick={handleSubmit}
              className="bg-[#016690] text-white py-2 rounded-full w-full"
            >
              Reset Password
            </button>

            {status === 'error' && (
  <div className="text-red-500 text-xs mt-2">
    Invalid link
  </div>
)}

{status === 'expired' && (
  <div className="text-red-500 text-xs mt-2">
    This link has expired. Please request a new one.
  </div>
)}
          </>
        )}

        <div className="text-[10px] text-gray-400 mt-6">
          Powered by Complement Group
        </div>

      </div>

      {/* RIGHT PANEL (IMAGE) */}
      <div className="flex-1 bg-gray-200">
        <img
          src="/your-image.jpg"
          alt="visual"
          className="w-full h-full object-cover"
        />
      </div>

    </div>
  );
}

export default ResetPassword;